export default {
      id: "icon--santa-reindeer-usage",
      viewBox: "0 0 28.9 31",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--santa-reindeer-usage",
      toString: function () {
        return this.url;
      }
    }